(() => {
  'use strict';
  const styleId = 'cafeoni-privacy-mobile-flow';
  const settingsPath = '/pages/cookie-einstellungen';
  let openedSettingsPage = false;
  function configurePrivacyAccess() {
    const root = document.getElementById('usercentrics-root');
    const shadow = root && root.shadowRoot;
    if (shadow && !shadow.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = '@media(max-width:767px){[data-testid="uc-privacy-button"]{position:static!important;inset:auto!important;margin:16px auto!important;transform:none!important;}}';
      shadow.appendChild(style);
    }
    if (!openedSettingsPage && location.pathname.replace(/\/$/, '') === settingsPath && window.UC_UI && window.UC_UI.isInitialized()) {
      openedSettingsPage = true;
      window.UC_UI.showSecondLayer();
    }
    return Boolean(shadow);
  }
  window.addEventListener('UC_UI_INITIALIZED', configurePrivacyAccess);
  window.addEventListener('UC_UI_VIEW_CHANGED', configurePrivacyAccess);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === settingsPath && window.UC_UI && window.UC_UI.isInitialized()) {
      event.preventDefault();
      window.UC_UI.showSecondLayer();
    }
  });
  if (!configurePrivacyAccess()) {
    const observer = new MutationObserver(() => {
      if (configurePrivacyAccess()) observer.disconnect();
    });
    observer.observe(document.body, {childList:true});
    window.addEventListener('UC_UI_INITIALIZED', () => observer.disconnect(), {once:true});
    window.setTimeout(() => observer.disconnect(), 15000);
  }
})();
